module.exports = __webpack_public_path__ + "a970189f332582ff3cfc33c8f891dda0.png";